import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      refetchInterval: 0,
      refetchOnWindowFocus: false,
      retryDelay: 3000,
      cacheTime: 0,
      retry: false,
      onError: (error: any) => {
        // Handle 401 errors globally for React Query
        if (error?.response?.status === 401) {
          // Clear session data
          localStorage.removeItem('sessionId');
          localStorage.removeItem('userId');

          // Dispatch custom event to notify store
          window.dispatchEvent(new Event('authStateCleared'));

          // Redirect to login page
          window.location.href = '/login';
        }
      },
    },
    mutations: {
      onError: (error: any) => {
        // Handle 401 errors globally for React Query mutations
        if (error?.response?.status === 401) {
          // Clear session data
          localStorage.removeItem('sessionId');
          localStorage.removeItem('userId');

          // Dispatch custom event to notify store
          window.dispatchEvent(new Event('authStateCleared'));

          // Redirect to login page
          window.location.href = '/login';
        }
      },
    },
  },
});
